import {ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';
import {BLOCKS_CONFIG} from '../../blocks.config';
import {SessionControllerService} from '../../../submission/src/app/session/session-controller.service';
import {PdfPartComponent} from '@blocks/pdf-part/pdf-part.component';
import {LocalizationService} from '@shared/i18n/localization.service';
import {ContentLocale} from '@paperlessio/sdk/api/util';
import {InputType, TextInput} from '@paperlessio/sdk/api/models';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class TextInputComponent implements OnInit {
  @ViewChild('input') input: NgModel;

  @Input() block: TextInput;
  @Input() slug: string;

  @Input() data: string;
  @Output() dataChange: EventEmitter<string> = new EventEmitter<string>();

  blocksConfig = inject(BLOCKS_CONFIG);
  cdr = inject(ChangeDetectorRef);

  ineligible = false;
  domId = '';

  InputType = InputType;

  private sessionController = inject(SessionControllerService, {optional: true});
  private pdfPartComponent = inject(PdfPartComponent, {optional: true});
  private localizationService = inject(LocalizationService);

  get isOverlay(): boolean {
    return !!this.pdfPartComponent;
  }

  ngOnInit(): void {
    if (this.blocksConfig.submittable) {
      this.domId = 'r' + (this.blocksConfig.editable ? 'e' : '') + (this.block.settings.editable ? 'q' : '');
      this.ineligible = this.sessionController && !this.sessionController.isParticipantAnOwnerOf(this.block.id);
    }
  }

  // TODO: After switching to reactive forms, we can migrate this to a Custom Validator
  setValue(event: string) {
    let value = event;

    if (this.block?.settings?.validate && this.block?.settings?.type === InputType.zip) {
      value = value.trim();
      setTimeout(() => {
        this.data = value;
        this.cdr.markForCheck();
      }, 1);
    }

    return (!this.block.settings.readonly || this.blocksConfig.editable || this.blocksConfig.preview) ? this.dataChange.emit(value) : false;
  }

  getPlaceholder(): string {
    const settings = this.block.settings;
    let placeholder;
    if (settings.hide_name) {
      placeholder = this.block.localizedName(this.currentContentLocale, this.originalContentLocale, true) || '';
    } else {
      placeholder = this.block.localizedPlaceholder(this.currentContentLocale, this.originalContentLocale, true) || '';
    }

    if (settings.required && settings.hide_name) {
      placeholder += ' *';
    }

    return placeholder;
  }

  getPlaceholderDanger(): boolean {
    if (!this.blocksConfig.localizable) {
      return false;
    }

    if (this.block.settings.hide_name) {
      return !this.block.localizedName(this.currentContentLocale, this.originalContentLocale);
    } else {
      return !this.block.localizedPlaceholder(this.currentContentLocale, this.originalContentLocale);
    }
  }

  get currentContentLocale(): ContentLocale {
    return this.localizationService.currentContentLocale;
  }

  get originalContentLocale(): ContentLocale {
    return this.localizationService.originalContentLocale;
  }

  get lengthOkay(): boolean {
    if (this.block.settings.validate && (this.block.settings.minLength > 0 || this.block.settings.maxLength > 0)) {
      if (this.block.settings.minLength > this.data?.length) {
        return false;
      } else if (this.block.settings.maxLength < this.data?.length) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
